export default {
  namespaced: true,
  state: {
    steps: [
      { index: 1, libelle: 'Saisie' },
      { index: 2, libelle: 'Décision' },
      { index: 3, libelle: "Demande d'achat ou Collecte de prix" },
    ],
    currentStep: 1,
  },

  getters: {
    steps: (state) => state.steps,
    currentStep: (state) => state.currentStep,
  },

  mutations: {
    SET_CURRENT_STEP(state, value) {
      state.currentStep = value;
    },
  },

  actions: {
    setCurrentStep({ commit }, payload) {
      let step = 1;
      switch (payload) {
        case 1:
        case 2:
          step = 2;
          break;
        case 3:
        case 4:
          step = 3;
          break;
        default:
          step = 1;
          break;
      }
      commit('SET_CURRENT_STEP', step);
    },
  },
};
